// extracted by mini-css-extract-plugin
export default {"divider":"divider--1yF2ej4tQa"};